import { FormEvent, useState } from 'react';

import { subscribe } from '../api/subscribers';

export default function SubscribePage() {
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState<{ ok: boolean; message: string } | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || !consent) {
      return;
    }
    setSubmitting(true);
    setResult(null);
    try {
      await subscribe(email, consent);
      setResult({ ok: true, message: 'Check your inbox — we sent you a confirmation email.' });
      setEmail('');
      setConsent(false);
    } catch (err) {
      setResult({
        ok: false,
        message: (err as Error).message ?? 'Something went wrong. Please try again.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: 480, margin: '48px auto', padding: '0 16px' }}>
      <h1>Subscribe to API updates</h1>
      <p style={{ color: 'var(--text-muted)' }}>
        Get notified whenever the SkyMap API documentation is updated — new versions, breaking
        changes, and migration guides.
      </p>

      {result ? (
        <div
          style={{
            padding: '16px',
            borderRadius: '8px',
            background: result.ok ? 'var(--success-bg)' : 'var(--danger-bg)',
            border: `1px solid ${result.ok ? 'var(--success-border)' : 'var(--danger-border)'}`,
            color: result.ok ? 'var(--success-text)' : 'var(--danger-text)',
            marginTop: '24px',
          }}
        >
          {result.message}
          {!result.ok && (
            <button
              style={{ marginLeft: 16, fontSize: 13, cursor: 'pointer' }}
              onClick={() => setResult(null)}
            >
              Try again
            </button>
          )}
        </div>
      ) : (
        <form style={{ marginTop: '24px' }} onSubmit={(e) => void handleSubmit(e)}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
            Email address
          </label>
          <input
            placeholder="you@example.com"
            required={true}
            style={{
              display: 'block',
              width: '100%',
              padding: '10px 12px',
              borderRadius: '6px',
              border: '1px solid var(--border-strong)',
              fontSize: '15px',
              boxSizing: 'border-box',
            }}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label
            style={{
              display: 'flex',
              gap: '10px',
              alignItems: 'flex-start',
              marginTop: '16px',
              cursor: 'pointer',
            }}
          >
            <input
              checked={consent}
              required={true}
              style={{ marginTop: '3px', flexShrink: 0 }}
              type="checkbox"
              onChange={(e) => setConsent(e.target.checked)}
            />
            <span style={{ fontSize: '14px', color: 'var(--text-primary)' }}>
              I agree to receive API documentation update emails from SkyMap Innovations. I can
              unsubscribe at any time using the link in any email.
            </span>
          </label>

          <button
            disabled={submitting || !email || !consent}
            style={{
              marginTop: '20px',
              padding: '10px 24px',
              background: 'var(--accent-solid)',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              fontSize: '15px',
              fontWeight: 600,
              cursor: submitting ? 'not-allowed' : 'pointer',
              opacity: submitting || !email || !consent ? 0.6 : 1,
            }}
            type="submit"
          >
            {submitting ? 'Sending…' : 'Subscribe'}
          </button>
        </form>
      )}
    </div>
  );
}
